import withBackend from '../backend/withBackend';
import AdminRoute from './AdminRoute';

export default withBackend(AdminRoute);
